import PopupRedesign, {CloseButton} from './PopupRedesign';

export default PopupRedesign;

export {
  CloseButton,
}
